import { Search } from 'lucide-react'

const Header: React.FC<{sideTab: string}> = ({sideTab}) => {
    return (
        <>
            {/* Header */}
            <header className="h-28 bg-background border-b border-gray-200 flex flex-col justify-start items-start py-3 px-4">
                <div className="flex items-center mx-auto">
                    <div className="relative w-[55vh] bg-[#1F1F1F] rounded-xl">
                        <input 
                            type="text" 
                            placeholder="Search anything..." 
                            className="w-full bg-[#1F1F1F] rounded-xl px-12 py-3 pr-4 text-white" 
                        />
                        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white" />
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <h1 className='text-white font-bold text-3xl'>{sideTab}</h1>
                    <div></div>
                </div>
            </header>
        </>
    )
}

export default Header